import React, { useEffect } from "react";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

function formatINR(num) {
  if (num == null) return "र 0";
  const n = Math.round(num);
  const str = n.toString();
  const last3 = str.slice(-3);
  const rest = str.slice(0, -3);
  const grouped = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
  return `र ${grouped ? grouped + "," + last3 : last3}`;
}

const centerTextPlugin = {
  id: "centerText",
  beforeDraw: (chart) => {
    const { ctx, chartArea: { top, bottom, left, right } } = chart;
    const centerX = (left + right) / 2;
    const centerY = (top + bottom) / 2 + 20;

    ctx.save();
    ctx.textAlign = "center";
    ctx.fillStyle = "#111827";
    ctx.font = "600 14px Inter, system-ui, -apple-system, 'Segoe UI', Roboto";
    ctx.fillText("Total Revenue", centerX, centerY - 18);
    ctx.font = "700 18px Inter, system-ui, -apple-system, 'Segoe UI', Roboto";
    const total = chart.config.options.custom?.totalLabel || "र 0";
    ctx.fillText(total, centerX, centerY + 6);
    ctx.restore();
  }
};

export default function SemiDonutChart({ values, height = 200 }) {
  const defaultValues = {
    total: 0,
    received: 0,
    outstanding: 0,
    baddebts: 0,
    yetToRaise: 0,
    issued: 0,
  };
  const finalValues = { ...defaultValues, ...values };
  const segments = [
    { label: "Received", value: finalValues.received },
    { label: "Outstanding", value: finalValues.outstanding },
    { label: "Bad Debts", value: finalValues.baddebts },
    { label: "Yet To Raise", value: finalValues.yetToRaise },
  ];
  const filteredSegments = segments.filter(seg => seg.value > 0);
  const chartColors = ["#10b98180", "#3b82f680", "#ec5837ed", "#f59e0b"];

  const data = {
  labels: filteredSegments.map(s => s.label),
  datasets: [
    {
      data: filteredSegments.map(s => s.value),
      backgroundColor: filteredSegments.map(
        (_, index) => chartColors[index % chartColors.length]
      ),
      borderWidth: 0,
    },
  ],
};

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    rotation: -90,
    circumference: 180,
    cutout: "70%",
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => `${context.label}: ${formatINR(context.raw)}`
        }
      }
    },
    custom: {
      totalLabel: formatINR(finalValues.total)
    }
  };

  useEffect(() => {}, []);

  return (
    <div className="w-full max-w-xl mx-auto p-2 bg-white rounded-2xl shadow-sm">
      <div className="flex items-center gap-2">
        <div className="w-2/4 h-48 relative">
          <Doughnut data={data} options={options} plugins={[centerTextPlugin]} height={height} />
        </div>

        <div className="w-2/4">
        <h6 class="mb-3">Revenue Status</h6>
          <div className="space-y-2">
              <div className="flex justify-between pt-2">
                  <div className="d-flex align-items-center justify-content-between w-full">
                    <p className="f-13 mb-2 flex items-center w-40"><i className="ti ti-circle-filled text-secondary me-1"></i> Issued</p>
                    <p className="f-13 fw-medium text-gray-9 mb-2 w-20 ms-2">{Math.round((finalValues.issued / finalValues.total) * 100) || 0}%</p>
                    <p className="f-13 fw-medium text-gray-9 mb-2 w-60">{formatINR(finalValues.issued)}</p>
                  </div>
              </div>

              {segments
              .filter(seg => seg.value > 0)
              .map((seg, index) => {
              const colors = ["#10b981", "#3b82f6", "#ec5837ed", "#f59e0b"]; // solid versions of chart colors
              const color = colors[index % colors.length];
                return (
                  <div key={seg.label} className={`flex justify-between pt-2 ${seg.label !== "Yet To Raise" ? "ms-2" : "" }`}>
                    <div className="d-flex align-items-center justify-content-between w-full">
                      <p className={`f-13 mb-2 flex items-center ${seg.label !== "Yet To Raise" ? "w-40 ms-2" : "w-40" }`}><i className="ti ti-circle-filled" style={{ color }}></i> {seg.label}</p>
                      <p className="f-13 fw-medium text-gray-9 mb-2 w-20">{Math.round((seg.value / finalValues.total) * 100) || 0}%</p>
                      <p className="f-13 fw-medium text-gray-9 mb-2 w-60">{formatINR(seg.value)}</p>
                    </div>
                  </div>
                );
              })}
          </div>
          <div class="bg-light br-5 box-shadow-xs p-2 pb-0 d-flex align-items-center justify-content-between flex-wrap">
									<div class="d-flex align-items-center">
										<p class="mb-2 me-2">Total Revenue</p>
									</div>
									<h6>{formatINR(values.total)}</h6>
								</div>
        </div>
      </div>
    </div>
  );
}
